import "../style/page/cashback.scss";
import { useEffect, useState, useMemo } from "react";
import {
  currentCashbackGetApi,
  pharmacydetails,
  product_return,
} from "../../text/apidata";
import axios from "axios";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import noimage from "../../assets/images/noimage.png";
import { sidebar } from "../redux/reducer/counterslice";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import pdf from "../../assets/images/pdf.png";
import noimage1 from "../../assets/images/noimage.png";
import Modal from "react-modal";

export default function AppoinmentDetails(props) {
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [data, setdata] = useState([]);
  const dispatch = useDispatch();
  const [doctorcount, setdoctorcount] = useState(0);
  const [appoinmentcount, setappoinmentcount] = useState(0);
  const [gender, setgender] = useState("all");
  const locationid = useSelector(state => state.counter.loginuser_location_id);

  const [branches, setbranches] = useState(
    locationid != "all" ? locationid : "91"
  );
  const [ageit, setageit] = useState("0");
  const [agegt, setagegt] = useState("120");
  const [datadownloadstate, setdatadownload] = useState("False");
  let roledata = localStorage.getItem("role");

  const [modalOpen, setModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");

  const [currentCashbackAmount, setCurrentCashbackAmount] = useState(0);

  const [cashbackReturnamount, setCashbackReturnAmount] = useState(0);
  const [returnData, setReturnData] = useState();
  const [revisedCashbackAmount, setRevisedCashbackAmount] = useState(0);
  const [errorAmount, setErrorAmount] = useState(false);
  const [cashBackAmount, setCashBackAmount] = useState(); // [cashBackAmount, setCashBackAmounts]
  const [id, setid] = useState();
  const [refetch, setRefetch] = useState(false);

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  // console.log(it, gt);
  const [range, setrange] = useState([it, it]);
  // console.log(range, dcount, "777777");
  useEffect(() => {
    props.loaderchange("true");
    axios({
      method: "get",
      url: pharmacydetails,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      params: {
        date_gt: range[0],
        date_lt: range[1],
        page: dtpageindex,
        page_size: dtpagesize,
        product_name: searchQuery,
        gender: gender,
        location: branches,
        age_lt: ageit != "" ? ageit : "0",
        age_gt: agegt != "" ? agegt : "120",
        generate_excel: datadownloadstate,
      },
    })
      .then(res => {
        console.log(res.data.data);
        setdata(res.data.data);
        if (res.data.data.data != undefined) {
          settableheaderdata(res.data.data.data);
        } else {
          window.open(res.data.data);
        }
        setdatadownload("False");
        setdatacount(res.data.data_count);
        setdoctorcount(
          "₹" +
            parseFloat(res.data.data.amount_paid)
              .toFixed(0)
              .replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
        );
        setappoinmentcount(res.data.data.appointment_count);

        props.loaderchange("false");
      })
      .catch(error => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  }, [
    range,
    dtpageindex,
    dtpagesize,
    searchQuery,
    gender,
    branches,
    ageit,
    agegt,
    datadownloadstate,
    appoinmentcount,
    refetch,
  ]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange(oldArray => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];

  const deleteappoinment = (e, ele) => {
    setReturnData(ele);
    setid(e);
    setCashbackReturnAmount(0);
    // setpopup(true);
    console.log(ele, "ksjjkaskkjsad");
    console.log(ele.id, ele.return_amount, ele.patient.id, "ahahhj");
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-info ",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "Do You Want To Add Return Amount?",
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "Return",
        cancelButtonText: "Partially used",
        reverseButtons: true,
      })
      .then(async result => {
        if (result.isConfirmed) {
          setCashbackReturnAmount(0);
          setCurrentCashbackAmount(0);
          setCashBackAmount(0);
          setErrorAmount(false);
          setModalOpen(true);
          setRemarks("");
          try {
            // ✅ Step 2: Call GET API after confirmation
            const getRes = await axios({
              method: "get",
              url: currentCashbackGetApi,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
              params: {
                phonenumber: ele?.patient?.phonenumber,
              },
            });

            console.log("✅ Cashback GET API Response:", getRes.data);

            if (getRes.data?.data) {
              setCurrentCashbackAmount(getRes.data?.data.cashback);
              console.log(getRes.data?.data, "Sadasdasdasdasd");
              // window.open(getRes.data.data, "_self");
            }
          } catch (err) {
            console.error("❌ Error in GET or POST API:", err);
            Swal.fire(
              "Error",
              "Something went wrong while processing.",
              "error"
            );
          }
        }
        // if (result.isConfirmed || result.dismiss === "cancel") {
        //   Swal.fire({
        //     title: "Enter Amount and remarks",
        //     html:
        //       '<input id="swal-input1" class="swal2-input" placeholder="Amount" type="number" value="' +
        //       ele.return_amount +
        //       '">' +
        //       '<textarea id="swal-input2" class="swal2-textarea" placeholder="Remarks" rows="3"></textarea>',
        //     showCancelButton: true,
        //     confirmButtonText: "Submit",
        //     showLoaderOnConfirm: true,
        //     preConfirm: () => {
        //       const amount = parseFloat(
        //         document.getElementById("swal-input1").value
        //       );
        //       const remarks = document.getElementById("swal-input2").value;
        //       if (!amount) {
        //         Swal.showValidationMessage("Amount Cannot Be Empty!");
        //       } else if (amount > ele.amount_before) {
        //         Swal.showValidationMessage(
        //           "Amount Cannot Exceed Initial Amount!"
        //         );
        //       }
        //       return { amount: amount, remarks: remarks };
        //     },
        //     inputValidator: (value, result) => {
        //       console.log(
        //         value,
        //         ele.base_amount,
        //         Math.min(value, ele.base_amount)
        //       );
        //       if (!value) {
        //         return "Amount Cannt Be Empty!";
        //       }
        //       // else if (Number(value) >= ele.base_amount) {
        //       //   return "Amount Cannot Be Greater Than Base Amount!";

        //       // }
        //     },
        //   }).then(result => {
        //     if (result.isConfirmed) {
        //       //         var amount1 = document.getElementById('amount1').value;
        //       // var amount2 = document.getElementById('amount2').value;
        //       var data1 = {
        //         type: "orderproducts",
        //         r_totalamount: Number(result.value.amount),
        //         order_id: ele.id,
        //         patient_id: ele?.patient?.id,
        //         remarks: result.value.remarks,
        //       };
        //       console.log(data1);
        //       axios({
        //         url: product_return,
        //         method: "post",
        //         data: data1,
        //         headers: {
        //           Authorization: "Bearer " + localStorage.getItem("token") + "",
        //         },
        //       })
        //         .then(Response => {
        //           setappoinmentcount(1);
        //           Swal.fire({
        //             //title: "Good job!",
        //             text: "Amount Added Successfully!",
        //             icon: "success",
        //           }).then(result => {
        //             setappoinmentcount(0);
        //           });
        //         })
        //         .catch(error => {});
        //     }
        //   });
        // }
      });
  };
  const columns = useMemo(
    () => [
      {
        Header: "Created date",
        accessor: "",

        Cell: row => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${
                  row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "Request from",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p>
                {row.row.original.request_from_hospital == true
                  ? "Hospital"
                  : "Home"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Bill ID",
        accessor: "",

        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.id.slice(-12)}
              >
                {String(row.row.original.id).slice(-12)}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={e => {
                  let isCopy = copy(String(row.row.original.id).slice(-12));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Wallet ID",
        accessor: "",

        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.wallet_id == null
                    ? "--"
                    : row.row.original.wallet_id
                }
              >
                {row.row.original.wallet_id == null
                  ? "--"
                  : row.row.original.wallet_id}
              </p>
              {/* <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(row.row.original.wallet_id);
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button> */}
            </>
          );
        },
      },
      {
        Header: "Patient Name",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",

        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {String(row.row.original.patient.p_uhid)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Ph.No",
        accessor: "",

        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.phonenumber}
              >
                {String(row.row.original.patient.phonenumber)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Address",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.address.location_range == null
                    ? ""
                    : row.row.original.address.location_range
                }
              >
                {row.row.original.address.address_line2}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={e => {
                  let string_convert = String(
                    row.row.original.address.address_line1 +
                      ", " +
                      row.row.original.address.address_line2 +
                      ". " +
                      row.row.original.address.latitude +
                      ", " +
                      row.row.original.address.longitude
                  );
                  let isCopy = copy(string_convert);
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Assigned By",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_by}
              >
                {row.row.original.assigned_by == null
                  ? "--"
                  : row.row.original.assigned_by}
              </p>
            </>
          );
        },
      },
      {
        Header: "Assigned To",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_to}
              >
                {row.row.original.assigned_to}
              </p>
            </>
          );
        },
      },
      {
        Header: "Delivery Ph.No",
        accessor: "",

        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.phone_number}
              >
                {row.row.original.phone_number == null
                  ? "--"
                  : row.row.original.phone_number}
              </p>
            </>
          );
        },
      },
      {
        Header: "Need Prescription",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.need_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.need_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },
      {
        Header: "No Prescription",
        accessor: "",

        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.no_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.no_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Prescription upload",
        accessor: "",
        Cell: row => {
          return (
            <>
              {row.row.original.upload_prescription &&
              row.row.original.upload_prescription.length > 0 ? (
                row.row.original.upload_prescription.map(ele => {
                  {
                    /* console.log(ele,"testajh") */
                  }
                  return (
                    <>
                      <a href={ele ? ele : noimage} target="_blank">
                        <img
                          style={{
                            height: "2.5rem",
                            width: "2.5rem",
                            borderRadius: "50%",
                            margin: "4px",
                          }}
                          src={ele ? ele : noimage1}
                        ></img>
                      </a>
                    </>
                  );
                })
              ) : (
                <>
                  <a href={noimage} target="_blank">
                    <img
                      style={{
                        height: "2.5rem",
                        width: "2.5rem",
                        borderRadius: "50%",
                        margin: "4px",
                      }}
                      src={noimage1}
                    ></img>
                  </a>
                </>
              )}
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "",
        Cell: row => {
          let status_data = row.row.original.status;
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                className={
                  status_data == "Confirming order"
                    ? "ordered"
                    : status_data == "Packing Order"
                    ? "packing"
                    : status_data == "In Transit"
                    ? "enroute"
                    : status_data == "Delivered"
                    ? "done"
                    : ""
                }
                data-tooltip-content={status_data}
              >
                {row.row.original.status}
              </p>
            </>
          );
        },
      },
      {
        Header: "Order closed",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.remove_from_order}
              >
                {row.row.original.remove_from_order == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Initial Amount",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.amount_before}
              >
                {parseFloat(row.row.original.amount_before).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Sample amount",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.base_amount}
              >
                {parseFloat(row.row.original.base_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Total Amount",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.total_amount}
              >
                {row.row.original.total_amount == null
                  ? "--"
                  : parseFloat(row.row.original.total_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Initial Wallet ",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.previous_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {parseFloat(row.row.original.previous_cashbackpoints).toFixed(
                  2
                )}
              </p>
            </>
          );
        },
      },
      {
        Header: "Wallet amount Used",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.used_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {parseFloat(row.row.original.used_cashbackpoints).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: row => {
          return (
            <>
              {row.row.original.ordercreaterazorpay != null ? (
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.ordercreaterazorpay.isPaid == false
                      ? "No"
                      : "Yes"
                  }
                >
                  {row.row.original.ordercreaterazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </p>
              ) : row.row.original.fully_used == false ? (
                <p style={{ color: "red", fontWeight: 700 }}>No</p>
              ) : (
                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
              )}
            </>
          );
        },
      },
      {
        Header: "Bill Request Pharmafile",
        accessor: "",
        Cell: row => {
          return (
            <>
              <span>
                <img
                  style={{
                    height: "2.5rem",
                    width: "2.5rem",
                    // borderRadius: "50%",
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    {
                      row.row.original.bill_request_pharmafile != null &&
                        window.open(
                          row.row.original.bill_request_pharmafile != null
                            ? row.row.original.bill_request_pharmafile
                            : ""
                        );
                    }
                  }}
                  className="pointer"
                  src={
                    row.row.original.bill_request_pharmafile != null
                      ? /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(
                          String(row.row.original.bill_request_pharmafile)
                        )
                        ? row.row.original.bill_request_pharmafile
                        : pdf
                      : noimage
                  }
                ></img>
              </span>
            </>
          );
        },
      },
      {
        Header: "Razorzor pay ID",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.ordercreaterazorpay == null
                    ? "--"
                    : row.row.original.ordercreaterazorpay.pharmacy_order_id
                }
              >
                {row.row.original.ordercreaterazorpay == null
                  ? "--"
                  : row.row.original.ordercreaterazorpay.pharmacy_order_id}
              </p>
            </>
          );
        },
      },
      {
        Header: "Return Amount",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.return_amount}
              >
                {parseFloat(row.row.original.return_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: row => {
          // console.log(row.row.original)
          //settablevalue(row.row.original)

          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  onClick={e => {
                    console.log(row.row.original, "dasdasdqwsadass");
                    deleteappoinment(row.row.original.id, row.row.original);
                  }}
                  // disabled={row.row.original.appointment.status == 0?false:true}
                  disabled={
                    row.row.original?.ordercreaterazorpay?.isPaid === true ||
                    row.row.original.fully_used === true
                      ? row.row.original.return_amount > 0
                        ? true
                        : false
                      : true
                  }
                >
                  <i class="bi bi-trash3"></i> Return
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const handleReturnAmountSubmit = async () => {
    try {
      // Validate before sending
      if (
        cashbackReturnamount > returnData?.amount_before ||
        cashbackReturnamount <= 0
      ) {
        Swal.fire(
          "Validation Error",
          "Amount Cannot Be Empty or Not Greater then Bill Amount!",
          "warning"
        );
        return;
      }

      const data1 = {
        type: "orderproducts",
        r_totalamount: Number(cashbackReturnamount),
        order_id: returnData?.id,
        patient_id: returnData?.patient?.id,
        remarks: remarks || "",
        return_type: "Pharmacy Order Detials",
        r_cashback_amount: Number(
          currentCashbackAmount >= cashBackAmount
            ? cashBackAmount.toFixed(2)
            : currentCashbackAmount.toFixed(2)
        ),
        r_real_amount:
          cashBackAmount <= Number(currentCashbackAmount.toFixed(2))
            ? cashbackReturnamount
            : (
                cashbackReturnamount -
                (cashBackAmount - Number(currentCashbackAmount.toFixed(2)))
              ).toFixed(2),
      };

      const postRes = await axios({
        url: product_return,
        method: "post",
        data: data1,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      console.log("✅ Return Amount POST API Response:", postRes.data);
      setRefetch(true);
      Swal.fire({
        text: "Amount Added Successfully!",
        icon: "success",
      });
    } catch (err) {
      console.error("❌ Error in POST API:", err);

      Swal.fire("Error", "Something went wrong while processing.", "error");
    } finally {
      setModalOpen(false);
    }
  };

  const pagesize = arg => {
    setdtPagesize(arg);
  };

  const pageindex = arg => {
    setdtPageindex(arg);
  };
  const handleSubmit = event => {
    event.preventDefault();
  };

  const datadownload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want To Download The Data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(result => {
      if (result.isConfirmed) {
        setdatadownload("True");
      } else {
        setdatadownload("False");
      }
    });
  };

  return (
    <>
      <div className={sideactive ? "dashboard-main-sa" : "dashboard-main"}>
        <div class="page-header">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Pharmacy Detials</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={e => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Pharmacy Details</li>
              </ul>
            </div>
            <div class="col-sm-5 col-auto">
              {" "}
              <div className="datepicker_dash">
                <DateRangePicker
                  defaultValue={[new Date(), new Date()]}
                  // disabledDate={(date) => isAfter(date, new Date())}
                  editable={false}
                  appearance="default"
                  placement="bottomEnd"
                  size="lg"
                  ranges={predefinedBottomRanges}
                  placeholder="From - To"
                  style={{ width: 270, padding: 10, float: "right" }}
                  onClean={e => cleaningrange(e)}
                  onChange={e => {
                    if (e != null) {
                      setrange([]);
                      e.forEach(newValue => {
                        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                        var localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate("validtill", localISOTime);
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body" style={{ padding: "1.5rem" }}>
              <div
                align="center"
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <a
                  class="dnbtn"
                  onClick={e => {
                    datadownload();
                  }}
                ></a>
              </div>

              <div className="row pt-4">
                <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-primary border-primary">
                          <i class="bi bi-cash-coin"></i>
                        </span>
                        <div class="dash-count">
                          <h3>{doctorcount != NaN ? doctorcount : ""}</h3>
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Amount Paid</h6>
                        {/* <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${doctorcount / 10}%` }}
                            aria-valuenow={doctorcount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-xl-4 col-sm-6 col-12 ">
                  <div class="card">
                    <div class="card-body" style={{ padding: "1.5rem" }}>
                      <div class="dash-widget-header">
                        <span class="dash-widget-icon text-danger border-danger">
                          <i class="bi bi-person-vcard-fill"></i>
                        </span>
                        <div class="dash-count">
                          <h3>
                            {appoinmentcount != NaN ? appoinmentcount : ""}
                          </h3>
                        </div>
                      </div>
                      <div class="dash-widget-info">
                        <h6 class="text-muted">Appointment</h6>
                        <div class="progress progress-sm">
                          <div
                            class="progress-bar bg-danger"
                            style={{ width: `${appoinmentcount / 10}%` }}
                            aria-valuenow={appoinmentcount}
                            aria-valuemin="0"
                            aria-valuemax="100%"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <form
                onSubmit={handleSubmit}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div
                  class="input-group rounded"
                  style={{ width: "250px", height: "40px" }}
                >
                  <input
                    type="search"
                    class="form-control rounded"
                    aria-label="Search"
                    aria-describedby="search-addon"
                    value={searchQuery}
                    onKeyDown={e => {
                      if (e.target.value.length === 0 && e.which === 32) {
                        e.preventDefault();
                      }
                    }}
                    onInput={e => {
                      if (e.target.value.length <= "100") {
                        setSearchQuery(e.target.value);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    // onKeyDown={(e)=>{if(e.which=="32"){
                    //   e.preventDefault()
                    // }}}

                    min="0"
                    max="10"
                    label="Search"
                    placeholder="Search..."
                    required
                  />
                  <span
                    class="input-group-text border-0 bg-transparent"
                    id="search-addon"
                  >
                    <i
                      class="bi bi-search"
                      style={{
                        color: "#1b5a90",
                        width: "20px",
                        height: "20px",
                      }}
                    ></i>
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label class="mr-2">From Age</label>
                    <input
                      type="number"
                      class="form-control mr-2"
                      style={{ width: "60px" }}
                      onWheel={e => {
                        document.activeElement.blur();
                      }}
                      placeholder="Age"
                      value={ageit}
                      onKeyDown={evt =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      onChange={e => {
                        if (e.target.value <= 120) {
                          setageit(e.target.value);
                        }
                      }}
                    ></input>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label class="mr-2">To Age</label>
                    <input
                      type="number"
                      class="form-control mr-2"
                      style={{ width: "60px" }}
                      onWheel={e => {
                        document.activeElement.blur();
                      }}
                      placeholder="Age"
                      value={agegt}
                      onKeyDown={evt =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      onChange={e => {
                        if (e.target.value <= 120) {
                          setagegt(e.target.value);
                        }
                      }}
                    ></input>
                    <div
                      class="input-group rounded mr-2"
                      style={{
                        width: "250px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <label class="mr-2">Gender</label>
                      <select
                        class="form-select"
                        value={gender}
                        name="gender"
                        onChange={e => {
                          setgender(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Filter By Gender...
                        </option>
                        <option value={"all"}>All</option>
                        <option value={"0"}>Male</option>
                        <option value={"1"}>Female</option>
                        <option value={"2"}>Others</option>
                        <option value={"3"}>Decline to State</option>
                      </select>
                    </div>

                    {/* <div
                      class="input-group rounded mr-2"
                      style={{ width: "250px", height: "40px", display: "flex", alignItems: "center" }}
                    >
                      <label class="mr-2">Branch</label>
                      <select
                        class="form-select"
                        value={branches}
                        name="gender"
                        onChange={(e) => {
                          setbranches(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Filter By Location...
                        </option>
                        <option value={"all"}>All</option>
                        <option value={"0"}>VELACHERY</option>
                        <option value={"1"}>CHETPET</option>
                        <option value={"2"}>KOLATHUR</option>
                      </select>
                    </div> */}
                  </div>
                </div>
              </form>
              <div className="table-responsive">
                <BasicTable
                  columns={columns}
                  data={tableheaderdata}
                  pagesize={pagesize}
                  pageindex={pageindex}
                  dtpagesize={dtpagesize}
                  dtpageindex={dtpageindex}
                  datacount={datacount}
                  location={"others"}
                  setbranches={setbranches}
                  branches={branches}
                />
              </div>
            </div>
          </div>
          <Modal
            isOpen={modalOpen}
            onRequestClose={() => setModalOpen(false)}
            style={{
              overlay: {
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1000,
              },
              content: {
                maxWidth: "550px",
                margin: "auto",
                padding: "20px",
                height: "auto",
                maxHeight: "490px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
              },
            }}
          >
            <h4 className="text_center_returnAmount">
              Enter Amount and Remarks
              {console.log(currentCashbackAmount, "sadaksdkjaldjad")}
            </h4>
            <p>
              Cashback Amount:{" "}
              <strong>₹{currentCashbackAmount.toFixed(2)}</strong>
            </p>
            <p>
              Cashback Reduce Amount:{" "}
              <strong>
                ₹
                {currentCashbackAmount >= cashBackAmount
                  ? cashBackAmount.toFixed(2)
                  : currentCashbackAmount.toFixed(2)}
              </strong>
            </p>
            <p>
              Cash Return Amount:{" "}
              <strong>
                ₹
                {cashBackAmount <= Number(currentCashbackAmount.toFixed(2))
                  ? cashbackReturnamount
                  : (
                      cashbackReturnamount -
                      (cashBackAmount -
                        Number(currentCashbackAmount.toFixed(2)))
                    ).toFixed(2)}
              </strong>
            </p>
            {/* {revisedCashbackAmount > 0 && ( */}
            {/* <p>
                                Revised Cashback Amount:{" "}
                                <strong>₹{revisedCashbackAmount.toFixed(2)}</strong>
                              </p> */}
            {/* )} */}
            <div
              className="form-group"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <input
                type="number"
                // value={cashbackReturnamount}
                onChange={e => {
                  console.log(returnData, "dakldakjdjklakjld");
                  let val = parseFloat(e.target.value) || 0;
                  if (val > returnData.amount_before) {
                    setErrorAmount(true);
                  } else if (val > returnData.total_amount) {
                    setRevisedCashbackAmount(val - returnData.total_amount);
                  } else {
                    setRevisedCashbackAmount(0);
                    setErrorAmount(false);
                  }
                  setCashBackAmount(val * (0.05).toFixed(2));
                  // if (val > totalCashback) val = totalCashback; // optional limit
                  setCashbackReturnAmount(val);
                }}
                className="input-box"
                placeholder="Return Amount"
              />
              {errorAmount && (
                <span style={{ color: "red" }}>
                  Return Amount Cannot Exceed Bill Amount
                </span>
              )}
              <textarea
                className="input-box"
                rows={3}
                placeholder="Remarks"
                value={remarks}
                onChange={e => setRemarks(e.target.value)}
              />
            </div>

            <div
              style={{
                marginTop: 10,
                display: "flex",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <button
                className="btn btn-primary"
                onClick={handleReturnAmountSubmit}
              >
                {"Submit"}
              </button>
              <button
                className="btn btn-info"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </Modal>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={50}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
    </>
  );
}
